import React from "react";
import classes from "./index.module.scss";
import Logo from "../../../assets/images/logo.svg";
import HappyAsians from "../../../assets/images/banner.jpg";

export function Header() {
  return (
    <div>
      <header className={classes.header}>
        <div className={classes.headerLogo}>
          <a href="https://www.prudential.com.vn">
            <img src={Logo} alt="logo" className={classes.logoImg} />
          </a>
        </div>
      </header>
      <section className={classes.bgPartial}>
        <img src={HappyAsians} className={classes.banner} alt="Happy Asians" />
      </section>
    </div>
  );
}
